import { nanoid } from 'nanoid'

const getAnswerChoicesInitialValues = (answerChoices) => {
  if (!answerChoices || !answerChoices.length) return {}

  return {
    answerChoices: answerChoices.map((choice) => ({ choice, id: nanoid(5) }))
  }
}

export const getInitialValues = (eventType) => ({
  inviteeQuestions: eventType.custom_fields
    .map((question) => ({
      ...question,
      ...getAnswerChoicesInitialValues(question.answer_choices),
      _destroy: question._destroy
    }))
})
